var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',[_vm._v(_vm._s(_vm.user.fullname))]),_c('small',[_vm._v(_vm._s(_vm.user.telephone))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }